<template>
  <div
    class="flex flex-wrap justify-center font-roboto"
    :class="
      tabsProfile
        ? 'justify-between max-w-[508px] px-6 xl:max-w-[initial] w-full xl:w-[calc(100%-100px)] mx-auto mt-[55px] xl:mx-[initial] xl:ml-[100px] xl:mt-[initial] xl:flex-col flex-wrap lg:flex-nowrap h-[initial] xl:h-[initial]'
        : 'shadow-drop-0 rounded-[8px]'
    "
  >
    <!-- :class="
      isTransparent ? 'text-ruby-red-100' : 'bg-ruby-red-100 text-white-100'
    " -->
    <NuxtLink
      v-for="(item, index) in list"
      :key="`tab-option-${index}`"
      class="text-smaller-caps flex cursor-pointer select-none items-center justify-center px-3 py-[7px] font-bold xl:px-6"
      :to="
        !tabsProfile
          ? {
              query: {
                content: item.model,
                group: route.query.group,
                ...extraQuery,
              },
            }
          : { path: item.model }
      "
      :class="[
        !tabsProfile
          ? currentTabIndex === index
            ? 'rounded-[8px] bg-ruby-red-100 text-white-100'
            : 'text-ruby-red-100'
          : currentTabIndex === index
          ? 'profile-tab current'
          : 'profile-tab',
        { 'pointer-events-none !text-[#ababab]': !item.count && !tabsProfile },
      ]"
      @click="handleChangeTab(index)"
    >
      <span
        v-if="isNotMobile || currentTabIndex === index || !item.icon"
        class="xl:text-[18px] xl:leading-[22px]"
        :class="{
          'whitespace-nowrap': getContent(item) !== 'Моя школьная программа',
        }"
      >
        {{ getContent(item) }}
      </span>

      <div
        v-if="item.icon"
        :class="{
          'ml-2': (isNotMobile || currentTabIndex === index) && !tabsProfile,
        }"
      >
        <div v-if="item.iconType === 'html'" v-html="item.icon"></div>
        <template v-else>
          <SvgIcon v-if="isMobile || isCommentTabs" :name="item.icon" />
        </template>
      </div>

      <span v-if="isCommentTabs && item.count" class="ml-2">
        {{ item.count }}
      </span>
    </NuxtLink>
  </div>
</template>

<script setup>
const props = defineProps({
  initialTabIndex: {
    type: Number,
    default: 0,
  },

  tabsProfile: {
    type: Boolean,
    default: false,
  },

  list: {
    type: Array,
    default: () => {
      return [
        {
          id: 0,
          label: 'Свежие',
          value: '',
          icon: 'timer',
          count: undefined,
        },
        {
          id: 1,
          label: 'Обсуждаемые',
          value: 'popular',
          icon: 'chat-circle',
          count: undefined,
        },
        {
          id: 2,
          label: 'Популярные',
          value: 'popular',
          icon: 'eye',
          count: undefined,
        },
        {
          id: 3,
          label: 'Любимые',
          value: 'popular',
          icon: 'like',
          count: undefined,
        },
      ];
    },
  },

  // isCollection: {
  //   type: Boolean,
  //   default: false,
  // },

  isCommentTabs: {
    type: Boolean,
    default: false,
  },

  // дополнительные query-параметры, которые нужно сохранить при смене вкладки
  extraQuery: {
    type: Object,
    default: () => ({}),
  },

  // isTransparent: {
  //   type: Boolean,
  //   default: false,
  // },
});

const route = useRoute();
const { isMobile, isNotMobile } = useBreakpoint();

const currentTabIndex = ref(props.initialTabIndex);

const handleChangeTab = (id) => {
  currentTabIndex.value = id;
};

watch(
  () => route.fullPath,
  () => {
    currentTabIndex.value = props.initialTabIndex;
  },
);

const getContent = (item) => {
  return item.count >= 0 ? `${item.name}: ${item.count}` : `${item.name}`;
};
</script>

<style lang="scss">
.profile-tab {
  @apply text-[#808080] xl:text-white-100 relative mb-4 lg:mb-12 p-0 w-fit justify-start before:absolute before:opacity-0 before:h-[2px] before:w-full xl:before:max-w-[150px] before:max-w-[100%] before:bg-ruby-red-100 before:transition before:duration-700 before:bottom-[-3px] before:left-0;
}
.profile-tab.current {
  @apply text-new-test-black xl:text-white-100 before:opacity-100;
}
</style>
